var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('game-form',{model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}}),_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.save}},[_vm._v("SAVE")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }